import React from 'react';
import { t } from 'i18next';
import { NumberService } from 'Services';
import styles from './ContentCardHelperTable.css';

type Props = {
    data: ProgressDetails;
};

const ContentCardHelperTable = ({ data }: Props) => {
    return (
        <table className={styles.table}>
            <tbody>
                {Object.entries(data).map(([key, value]) => (
                    <tr data-testid='SidePanel-helper-data' key={key}>
                        <td data-testid={`key-${key}`}>{t(`${key}`)}</td>
                        <td data-testid={`value-${key}`} className={styles.tableRightColumn}>
                            {typeof value === 'number' ? NumberService.getLocaleNumber(value) : value}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default ContentCardHelperTable;
